/* global Blockly */
import React from 'react';
import util from "../../../../../../utils/es5Utils";

function defineBlock(context) {
    return {
        innerWidgets : [
            ['- select -', 'InnerWidgetName']
        ],

        init: function () {
            let selectRepeaterDropdown = new Blockly.FieldWidgetsDropdown(context, 'repeater', undefined, '- select -');
            let selectInnerWidgetDropdown = new Blockly.FieldDropdown([['','']], undefined, '- select -');

            this.appendDummyInput('INNERWIDGET')
                .appendField("get value")
                .appendField(selectInnerWidgetDropdown, "INNERID");

            this.appendDummyInput('WIDGET')
                .appendField("of current entry for")
                .appendField(selectRepeaterDropdown, "ID");

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "Number");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the value of specified inner widget of current entry for repeater widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#repeater`);
        },

        // handle repeater id dropdown changed
        onchange: function(e) {
            if (e.name != "ID" || e.newValue == e.oldValue || e.blockId != this.id) {
                return;
            }
            this.ID = this.getFieldValue('ID');
            this.getInnerWidgets(this.ID);
            this.updateInnerWidgets();
        },

        // gather inner widgets
        getInnerWidgets: function (parentWidgetId){
            this.innerWidgets = [];
            for (let i = 0; i < context.pages.length; i++){
                let page = context.pages[i];
                for(let j = 0; j < page.widgets.length; j++){
                    let widget = page.widgets[j];
                    if (widget.formId === parentWidgetId && 
                        ['textbox', 'rating', 'checkboxlist', 'flipswitch', 'radiobuttonlist', 'dropdown', 'date'].includes(widget.type)) {
                        this.innerWidgets.push([widget.name, widget.id]);
                    }
                }
            }
            if (this.innerWidgets.length === 0) {
                this.innerWidgets = [['- select -', 'InnerWidgetName']];
            }
        },

        // render inner widgets
        updateInnerWidgets: function() {
            let input = this.getInput("INNERWIDGET");
            input.removeField("INNERID");
            input.appendField(new Blockly.FieldDropdown(this.innerWidgets), "INNERID");
        },

        // create XML to represent list inputs.
        mutationToDom: function() {
            let container = Blockly.utils.xml.createElement('mutation');
            container.setAttribute('ID', this.getFieldValue('ID'));
            container.setAttribute('INNERID', this.getFieldValue('INNERID'));
            return container;
        },

        // parse XML to restore the list inputs
        domToMutation: function(xml){
            let ID = xml.getAttribute("ID");
            this.getInnerWidgets(ID);
            this.updateInnerWidgets();
        },
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let repeaterId = block.getFieldValue('ID');
            let innerWidgetId = block.getFieldValue('INNERID');
            let code = `Snap.widgets.repeater.getCurrentEntryValue("${repeaterId}", "${innerWidgetId}")`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const RepeaterEntryValue = function (props) {
    const name = 'snap_repeater_entry_value';
    RepeaterEntryValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}>
                {props.widget && (props.widget.id !== undefined)
                    ? <field name='INNERID'>{props.widget.id}</field>
                    : null
                }
            </block>;
}

export default RepeaterEntryValue;
